navApp.directive('navbranch', [
  '$document', '$timeout', 'templatePath', 'endpointDomain', 'NavStateService', 'getNavBranchItemsWithCallouts', 'updateHeight', function($document, $timeout, templatePath, endpointDomain, NavStateService, getNavBranchItemsWithCallouts, updateHeight) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        item: '='
      },
      templateUrl: 'navbranch.html',
      link: function(scope, element, attrs) {
        var section, timer;
        scope.navStateService = NavStateService;
        scope.hasChildren = angular.isArray(scope.item.children) && scope.item.children.length > 0;
        scope.itemsWithCallouts = getNavBranchItemsWithCallouts([scope.item]);
        timer = void 0;
        section = element[0].querySelectorAll('.nav-section');
        if (section.length > 0) {
          scope.section = {
            section: section
          };
        }
        scope.activateItem = function(item, navlevel, e, delay) {
          if (delay == null) {
            delay = 0;
          }
          if (scope.hasChildren) {
            e.preventDefault();
          }
          return timer = $timeout(function() {
            NavStateService.closeAll();
            if (scope.hasChildren) {
              return scope.navStateService.showItem(scope.navkey, scope.$id, navlevel);
            }
          }, delay);
        };
        scope.cancelOpen = function() {
          return $timeout.cancel(timer);
        };
        scope.indentClass = (function() {
          switch (attrs.navkey) {
            case 'primary':
              return '';
            default:
              return 'container-indent';
          }
        })();
        $document.on('click', function(e) {
          scope.cancelOpen();
          return scope.$apply(NavStateService.closeAll());
        });
        element.on('click', function(e) {
          return e.stopPropagation();
        });
        scope.navkey = attrs.navkey;
        return scope.updateCallout = function() {
          if (scope.navStateService.hasCallout(scope.$parent.item)) {
            NavStateService.updateCallout(scope.navkey, scope.$parent.item);
            return updateHeight(element);
          }
        };
      }
    };
  }
]);
